import { type MouseEventHandler, memo } from 'react';

import { XIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

export type SearchFieldClearButtonProps = {
  className?: string;
  'data-testid'?: string;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
};

export const SearchFieldClearButton = memo(
  ({ className, 'data-testid': dataTestId, label, onClick, onMouseDown }: SearchFieldClearButtonProps) => {
    return (
      <Button
        appearance="ghost"
        className={cn('gap-1 rounded-full ads:text-primary text-12 text-gray-12', className)}
        color="gray"
        data-testid={dataTestId}
        onClick={onClick}
        onMouseDown={onMouseDown}
        size="medium"
      >
        <XIcon aria-hidden size="xs" />
        {label}
      </Button>
    );
  },
);

SearchFieldClearButton.displayName = 'SearchFieldClearButton';
